module.exports = __webpack_public_path__ + "img/松芝.png";